export const MEETING_BRIEF_REPORT = {
  headline: 'Brief sent for Vantage Capital at 15:00',
  status: 'done',
  durationSec: 62,
  body: `**Brief for your 15:00 with Vantage Capital** — also sent to your inbox.

**Who they are:** a growth-stage investor focused on B2B data and infrastructure software.

**Attendees**

- **Nadia Rahman**, Partner — led their last two data-tooling investments.
- **Leo Park**, Associate — first meeting; recently wrote about “AI-native BI”.

**History:** no prior contact in HubSpot; the intro came through Daniel Brooks.

**Three questions to ask**

1. What would they need to see in the next two quarters to lead a round?
2. How do they think about AI agents versus traditional BI seats?
3. Which portfolio companies could be design partners?`,
}
